import { useEffect, useRef, useState } from 'react';

export const useMeasureOverflow = <T extends HTMLElement>() => {
  const measureRef = useRef<T>(null);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const [isMeasured, setIsMeasured] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      const checkOverflow = () => {
        if (measureRef.current && !isMeasured) {
          const { scrollHeight, clientHeight } = measureRef.current;
          setIsOverflowing(scrollHeight > clientHeight);
          setIsMeasured(true);
        }
      };

      checkOverflow();
    });
  }, [isMeasured]);

  return { measureRef, isOverflowing, isMeasured };
};
